{
  "watchOnYoutube": "Ver en youtube",
  "watchOnYoutubeLabel": "Ver [0] en youtube"
}
